// extracted by mini-css-extract-plugin
export default {"main-content":"Textarea_main-content__xrqXg","textarea":"Textarea_textarea__x3cke","requiredSymbol":"Textarea_requiredSymbol__aIbKj","hasErrors":"Textarea_hasErrors__3faJI"};